
// Mock comments data for video comments section
export interface VideoComment {
  id: string;
  videoId: string;
  username: string;
  avatar: string;
  comment: string;
  timestamp: string;
  likes: number;
}

export const mockComments: VideoComment[] = [
  {
    id: 'c1',
    videoId: 'real-1',
    username: 'CatLover2024',
    avatar: 'https://public.readdy.ai/ai/img_res/cec5ad635665d2c7d494484a4b9fbdf8.jpg',
    comment: 'This is the cutest thing I have ever seen! My cat does the exact same thing 😂',
    timestamp: '2 hours ago',
    likes: 24,
  },
  {
    id: 'c2',
    videoId: 'real-1',
    username: 'WhiskersFan',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20gray%20cat%20avatar%20icon%2C%20simple%20design%2C%20fluffy%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar2&orientation=squarish',
    comment: 'I cannot stop watching this! So adorable!',
    timestamp: '5 hours ago',
    likes: 18,
  },
  {
    id: 'c3',
    videoId: 'real-1',
    username: 'PurrfectMoments',
    avatar: 'https://readdy.ai/api/search-image?query=sweet%20cartoon%20white%20cat%20avatar%20icon%2C%20simple%20cute%20design%2C%20blue%20eyes%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar3&orientation=squarish',
    comment: 'Made my whole day better! Thanks for sharing this gem.',
    timestamp: '1 day ago',
    likes: 42,
  },
  {
    id: 'c4',
    videoId: 'real-2',
    username: 'KittyQueen',
    avatar: 'https://readdy.ai/api/search-image?query=adorable%20cartoon%20calico%20cat%20avatar%20icon%2C%20simple%20design%2C%20colorful%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar4&orientation=squarish',
    comment: 'Those little paws! I am melting over here!',
    timestamp: '3 hours ago',
    likes: 31,
  },
  {
    id: 'c5',
    videoId: 'real-2',
    username: 'MeowMaster',
    avatar: 'https://readdy.ai/api/search-image?query=cool%20cartoon%20black%20cat%20avatar%20icon%2C%20simple%20design%2C%20yellow%20eyes%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar5&orientation=squarish',
    comment: 'This reminds me of when my kitten was this small. Time flies!',
    timestamp: '8 hours ago',
    likes: 15,
  },
];

// Get comments for a specific video
export const getCommentsForVideo = (videoId: string): VideoComment[] => {
  // Return mock comments, cycling through them for any video
  const baseComments = mockComments.map((c, index) => ({
    ...c,
    id: `${videoId}-${index}`,
    videoId,
  }));
  return baseComments.slice(0, 3 + Math.floor(Math.random() * 3));
};
